//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'
import PlansMixin from '~/mixins/plans'

export default {
  mixins: [PlansMixin],
  props: {
    /**
     * Whether to show the pay now button
     */
    showPayNowButton: {
      type: Boolean,
      required: true
    },
    isPayUpfrontActiveAb: {
      type: Boolean,
      deafult: false
    }
  },
  computed: {
    ...mapState('product', ['baseCompleteTests', 'improvementProgramPrice']),
    ...mapGetters({
      getBaseCompletePlusProgramPrice: 'product/getBaseCompletePlusProgramPrice',
      isBaseCompleteImprovementPlan: 'product/isBaseCompleteImprovementPlan',
      isBaseImprovementPlan: 'product/isBaseImprovementPlan',
      isQuizPlanResults: 'product/isQuizPlanResults',
      getPlanPriceRaw: 'product/getPlanPriceRaw',
      getImprovementProgramPrice: 'product/getImprovementProgramPrice'
    }),
    specifications () {
      return this.isPayUpfrontActiveAb ? this.$t('completeTestingPlan.header.specificationsB') : this.$t('completeTestingPlan.header.specifications')
    }
  },
  methods: {
    trackAddToCart () {
      this.trackFBPixelEvent({
        event: 'AddToCart',
        properties: {
          plan: this.planSelected
        }
      })
      this.trackTikTokEvent({
        event: 'AddToCart',
        properties: {
          content_type: 'product',
          content_id: this.planSelected,
          content_name: this.planSelected
        }
      })
    },
    openRemoveQuizPlanModal () {
      if (this.isQuizPlanResults || this.isBaseImprovementPlan) {
        this.$emit('openRemoveQuizPlanModal')
      } else {
        this.trackAddToCart()
        if (this.isPayUpfrontActiveAb) {
          this.$store.dispatch('product/selectBaseCompleteImprovementPlanPayUpfront')
        } else {
          this.$store.dispatch('product/selectBaseCompleteImprovementPlan')
        }
      }
    }
  }
}
